import React, { useEffect, useState } from "react"
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Collapse,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap"

// Import Editor
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"

//Import Date Picker
import "react-datepicker/dist/react-datepicker.css"
import PropTypes from "prop-types"
import usePermission from "helpers/permission/usePermission"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import {
  buscarFornecedoresNomeCNPJ,
  buscarPlanoContas,
} from "store/auth/profile/actions"
import moment from "moment"
import FormInputText from "../../components/Common/form-input-text"
import FormInputDate from "../../components/Common/form-input-date"
import FormInputSelect from "../../components/Common/form-input-select"
import FormInputMoney from "../../components/Common/form-input-money"
import FormSelectCompany from "../../components/Common/form-select-company"

const FREQ_LABEL_MAP = { S: "semanal", Q: "quinzenal", M: "mensal", B: "bimestral", T: "trimestral", E: "semestral", A: "anual" }

const PagamentoLancamentoModal = props => {

  const { t, despesa, isOpen, toggle, saveLancamento, companies } = props

  const [valor, setValor] = useState()
  const [valorPago, setValorPago] = useState()
  const [descricao, setDescricao] = useState()
  const [contas, setContas] = useState()

  const [pagamento, setPagamento] = useState()
  const [multa, setMulta] = useState()
  const [juros, setJuros] = useState()
  const [desconto, setDesconto] = useState()
  const [contaPagamento, setContaPagamento] = useState()
  const [cheque, setCheque] = useState()
  const [impresso, setImpresso] = useState()
  const [observacao, setObservacao] = useState()

  const [company, setCompany] = useState("")
  const [opcoesAvancada, setOpcoesAvancada] = useState(false)

  const usePermissionEdit = usePermission('contasPagar_editar')

  useEffect(() => {
    // FormInputDate trabalha com objeto Date; usa moment com "YYYY-MM-DD" para
    // pegar o dia sem deslocamento de timezone.
    setPagamento(
      despesa?.data_pagamento
        ? moment(despesa.data_pagamento, "YYYY-MM-DD").toDate()
        : new Date()
    )
    setValor(despesa?.valor_real || 0)
    setValorPago(despesa?.valor_pago || despesa?.valor_real || 0)
    setDescricao(despesa?.descricao)
    setObservacao(despesa?.obs)
    setMulta(despesa?.multa || 0)
    setJuros(despesa?.juros || 0)
    setDesconto(despesa?.desconto || 0)
    setContaPagamento(despesa?.conta_pagamento)
    setCheque(despesa?.cheque)
    setImpresso(
      despesa?.impresso
        ? moment(despesa.impresso, "YYYY-MM-DD").toDate()
        : null
    )
    if (despesa?.idEmpresa) setCompany(despesa.idEmpresa)
    setOpcoesAvancada(false)
  }, [despesa])

  useEffect(() => {
    const opcoesCompany = (companies || []).filter(option => option.value)
    const companyValue =
      opcoesCompany.length > 0 ? opcoesCompany[0].value : undefined
    setCompany(despesa?.idEmpresa || companyValue)

    if (companyValue) {
      props.buscarPlanoContas({ company: companyValue })
    }
  }, [companies])

  useEffect(() => {
    if (company) {
      props.buscarPlanoContas({ company: company })
    }
  }, [company])


  useEffect(() => {
    if (Array.isArray(props.planoContas)) {
      const contas = props.planoContas.map(plano => ({
        label: `${plano.codigo} - ${plano.descricao}`,
        value: plano.codigo,
      }))
      setContas(contas)
    } else {
      setContas([])
    }
    return () => {
      setContas([])
    }
  }, [props.planoContas])

  // Diferença entre o valor da despesa e o efetivamente pago.
  const diferenca = Number(((valor || 0) - (valorPago || 0)).toFixed(2))

  const save = () => {
    let valid = true
    valid = valid && (!!pagamento)
    valid = valid && (!!valorPago)
    valid = valid && (!!contaPagamento)

    if(valid) {
      salvarLancamento()
    } else {
      const divs = document.getElementsByName("validate-required")
      for (let i = 0; i < divs.length; i++) {
        divs[i].style.display = "block"
      }
    }
  }

  const salvarLancamento = () => {
    const lancamento = despesa ? Object.assign({}, despesa) : {}
    lancamento.data_pagamento = pagamento
    // O valor efetivamente pago é persistido em valor_pago; valor_real (valor
    // original da despesa) permanece inalterado.
    lancamento.valor_pago = valorPago || 0
    lancamento.obs = observacao
    lancamento.multa = multa || 0
    lancamento.juros = juros || 0
    lancamento.desconto = desconto || 0
    lancamento.conta_pagamento = contaPagamento
    lancamento.cheque = cheque
    lancamento.impresso = impresso
    saveLancamento(lancamento)
  }

  return (
    <React.Fragment>
      { despesa && (
        <Modal
          isOpen={ isOpen }
          role="dialog"
          autoFocus={ true }
          centered={ true }
          tabIndex="-1"
          scrollable={ true }
          size="xl"
          toggle={ toggle }>
          <div className="modal-content">
            <ModalHeader toggle={ toggle }>
              { despesa?.id
                ? t("contaspagar.modal.editar.titulo", { id: despesa.id })
                : t("contaspagar.modal.pagamento.titulo") }
              { despesa?.id && despesa?.recorrencia && (
                <span className="badge bg-info ms-2 align-middle">
                  <i className="mdi mdi-repeat me-1" />
                  { t("contaspagar.modal.editar.recorrencia", {
                    frequencia: t(
                      `contaspagar.recorrencia.frequencia.${
                        FREQ_LABEL_MAP[despesa.recorrencia.frequencia] ||
                        "mensal"
                      }`
                    ),
                    qtd: despesa.recorrencia.qtd_geradas || 0,
                  }) }
                </span>
              ) }
            </ModalHeader>
            <ModalBody>
              <form>
                <div className="outer">
                  <div className="outer">
                    <div className="cp-form-grid">
                      <Row>
                        <Col md="6">
                          <FormSelectCompany
                            attribute="empresa"
                            description={ t("contaspagar.modal.pagamento.empresa") }
                            value={ company }
                            setValue={ setCompany }
                            options={ (companies || []).filter(c => c.value) }
                            disabled={ true }
                          />
                        </Col>
                        <Col md="6">
                          <FormInputDate
                            attribute="data_pagamento"
                            description={ t("contaspagar.modal.pagamento.data_pagamento") }
                            value={ pagamento }
                            setValue={ setPagamento }
                            required
                          />
                        </Col>
                      </Row>

                      <Row>
                        <Col md="6">
                          <FormInputMoney
                            attribute="valor"
                            description={ t("contaspagar.modal.pagamento.valor") }
                            value={ valor }
                            disabled={ true }
                          />
                        </Col>
                        <Col md="6">
                          <FormInputMoney
                            attribute="valor_pago"
                            description={ t("contaspagar.modal.pagamento.valor_pago") }
                            value={ valorPago }
                            setValue={ setValorPago }
                            required
                          />
                        </Col>
                      </Row>

                      { diferenca !== 0 && (
                        <Row>
                          <Col md="6" />
                          <Col md="6">
                            <FormInputMoney
                              attribute="diferenca"
                              description={ t("contaspagar.modal.pagamento.diferenca") }
                              value={ diferenca }
                              disabled={ true }
                            />
                          </Col>
                        </Row>
                      ) }

                      <Row>
                        <Col md="6">
                          <FormInputText
                            attribute="descricao"
                            description={ t("contaspagar.modal.pagamento.descricao") }
                            value={ descricao }
                            setValue={ setDescricao }
                            disabled={ true }
                          />
                        </Col>
                        <Col md="6">
                          <FormInputSelect
                            attribute="centro_custo_pagamento"
                            description={ t("contaspagar.modal.pagamento.centro_custo") }
                            value={ contaPagamento }
                            setValue={ setContaPagamento }
                            options={ contas || [] }
                            required
                          />
                        </Col>
                      </Row>

                      <Row>
                        <Col md="6">
                          <FormInputMoney
                            attribute="multa"
                            description={ t("contaspagar.modal.pagamento.multa") }
                            value={ multa }
                            setValue={ setMulta }
                          />
                        </Col>
                        <Col md="6">
                          <FormInputMoney
                            attribute="juros"
                            description={ t("contaspagar.modal.pagamento.juros") }
                            value={ juros }
                            setValue={ setJuros }
                          />
                        </Col>
                      </Row>

                      <Row>
                        <Col md="6">
                          <FormInputMoney
                            attribute="desconto"
                            description={ t("contaspagar.modal.pagamento.desconto") }
                            value={ desconto }
                            setValue={ setDesconto }
                          />
                        </Col>
                        <Col md="6">
                          <FormInputText
                            attribute="observacao"
                            description={ t("contaspagar.modal.pagamento.observacao") }
                            value={ observacao }
                            setValue={ setObservacao }
                          />
                        </Col>
                      </Row>
                    </div>

                    <div id="accordion">
                      <Card className="mb-1">
                        <CardHeader className="p-3" id="headingOne">
                          <h6 className="m-0 font-14">
                            <span
                              onClick={() => {
                                setOpcoesAvancada(!opcoesAvancada)
                              }}
                              style={{ cursor: "pointer" }}
                              className="text-dark "
                            >
                              { t("contaspagar.modal.criar.avancado") }
                            </span>
                          </h6>
                        </CardHeader>
                        <Collapse isOpen={opcoesAvancada}>
                          <Card>
                            <CardBody>
                              <FormInputText
                                attribute="cheque"
                                description={ t("contaspagar.modal.pagamento.cheque") }
                                value={ cheque }
                                setValue={ setCheque }
                              />

                              <FormInputDate
                                attribute="impresso"
                                description={ t("contaspagar.modal.pagamento.impresso") }
                                value={ impresso }
                                setValue={ setImpresso }
                              />
                            </CardBody>
                          </Card>
                        </Collapse>
                      </Card>
                    </div>
                  </div>
                </div>
              </form>
            </ModalBody>
            <ModalFooter>
              <Button type="submit" color="primary" disabled={ !usePermissionEdit } onClick={ save }>
                { t("contaspagar.modal.pagamento.botao.pagar") }
              </Button>
              <Button type="button" color="secondary" className="ms-2" onClick={ toggle }>
                { t("contaspagar.modal.pagamento.botao.fechar") }
              </Button>
            </ModalFooter>
          </div>
        </Modal>
      ) }
    </React.Fragment>
  )
}

PagamentoLancamentoModal.propTypes = {
  t: PropTypes.func,
  toggle: PropTypes.func,
  saveLancamento: PropTypes.func,
  isOpen: PropTypes.bool,
  despesa: PropTypes.object,
  companies: PropTypes.array,
  planoContas: PropTypes.array,
  buscarPlanoContas: PropTypes.func,
}

const mapStatetoProps = state => {
  const {
    fornecedores,
    fornecedoresLoading,
    planoContas,
    planoContasLoading
  } = state.Profile
  return {
    fornecedores,
    fornecedoresLoading,
    planoContas,
    planoContasLoading
  }
}

const bindActionToPromise = (dispatch, actionCreator) => (payload) => {
  return new Promise((resolve, reject) => dispatch(actionCreator(payload, { resolve, reject })));
};

function mapDispatchToProps(dispatch) {
  return {
    buscarFornecedores : bindActionToPromise(dispatch, buscarFornecedoresNomeCNPJ),
    buscarPlanoContas: () => buscarPlanoContas
  }
}

export default connect(mapStatetoProps, mapDispatchToProps)(withTranslation()(PagamentoLancamentoModal))
